import React,{Component} from 'react'

class Alert extends Component{

    render(){
      let extraStyles={
        position: "fixed",
        zIndex: 2000000,
        left:50,
        bottom: 30,
        transition: "0.5s"
      }

      let classes = "";

      console.log(extraStyles.left)

      this.props.open ? extraStyles.bottom = 30 : extraStyles.bottom = -150;
      this.props.mode == "warning" ? classes = "bgc-amber-400 bd bdc-amber-600" : this.props.mode == "error" ? classes = "bgc-red-400 bd bdc-red-600" : classes = "bgc-green-400 bd bdc-green-600"

      return(
        <div style={extraStyles} class={"custom-toast " + classes} >
            <div onClick={this.props.close} class="custom-toast-text-close">
                <i class="fa fa-times c-white"></i>
            </div>
            <i class="custom-toast__icon fa fa-check"></i>
            <div class="custom-toast__text">
                <div class="custom-toast-text-block">
                    <div class="custom-toast-text-block__title c-white">
                        {this.props.title}
                    </div>
                    <div class="custom-toast-text-block__message c-white">
                        {this.props.message}
                    </div>
                </div>
            </div>
        </div>
      )
    }
}

export default Alert



// WEBPACK FOOTER //
// ./src/global/Alert.js